import { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useNavigate } from 'react-router-dom';



import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Divider from '@mui/joy/Divider';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import Grid from '@mui/joy/Grid';


import { CollabInviteProps } from 'stores/collab_invite_store';

import { UserIdentityContext } from '../contexts/user_identity_context';
import { Success, Error } from './FancyToast';
import IdentityAvatar from './IdentityAvatar';
import IdentityBio from './IdentityBio';

import useCollabInvite from 'hooks/useCollabInvite';
import useWorkKey from 'hooks/useWorkKey';

const InviteActions = observer(({ invite }: { invite: CollabInviteProps }) => {
    const { currentIdentity } = useContext(UserIdentityContext);
    const { acceptCollabInvite } = useCollabInvite();
    const workKey = useWorkKey();
    const [accepting, setAccepting] = useState(false);
    const [selectedIdentityKey, _] = useState(currentIdentity.key);
    const [errorAccepting, setErrorAccepting] = useState(false);
    const navigate = useNavigate();

    function doAccept() {
        if (!workKey) {
            Error("No identity loaded");
            return;
        }
        setAccepting(true);
        acceptCollabInvite(invite.key, selectedIdentityKey)
            .then((data) => {
                Success("Invite accepted. Let's get to work!");
                setAccepting(false);
                navigate(`/collab/${data.associated_uuid}`);
            })
            .catch(() => {
                Error("Cannot join this collab, try another one");
                setAccepting(false);
                setErrorAccepting(true);
            });

    }

    function doBack() {
        window.history.back();
    }

    return (
        <Stack mt={2}>

            <Card>
                <CardContent>

                    <Stack spacing={2}>
                        <Typography level="title-md">
                            Are you ready to work on this right now?
                        </Typography>
                        <Divider />
                        <Grid container>
                            <Grid xs={12} sm={6}>
                                <Typography level="title-md">
                                    This is how you'll appear:
                                </Typography>

                                <Stack spacing={2} m={1}>

                                    <Sheet >
                                        <Stack p={1} spacing={1}>
                                            <IdentityAvatar
                                                interactive={false}
                                                identityKey={currentIdentity.key}
                                                size="inline" />
                                            <Divider />
                                            <IdentityBio identityKey={currentIdentity.key} />
                                        </Stack>
                                    </Sheet>
                                </Stack>
                            </Grid>
                            <Grid xs={12} sm={6}>

                                <Stack spacing={2}>
                                    <Typography level="title-md">
                                        Let's go!
                                    </Typography>
                                    <Stack spacing={1}>
                                        <Typography level="body-xs">
                                            Click accept to get started.
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Stack>
                </CardContent>

                {accepting &&
                    <CardActions>
                        <Typography
                            sx={{ ml: 'auto' }}
                            level="body-xs">
                            Accepting invite...
                        </Typography>
                    </CardActions>
                }

                {!accepting && !errorAccepting &&
                    <CardActions>
                        <Button
                            sx={{ ml: 'auto' }}
                            onClick={() => doBack()}
                            variant="outlined">Back</Button>
                        <Button
                            onClick={() => doAccept()}
                            color="primary">Accept</Button>
                    </CardActions>
                }
                {errorAccepting &&
                    <CardActions>
                        <Button
                            onClick={() => doBack()}
                            variant="outlined">Back</Button>
                        <Typography
                            sx={{ ml: 'auto' }}
                            level="body-xs">
                            Error accepting invite.
                        </Typography>

                    </CardActions>
                }

            </Card>
        </Stack>
    );
});
export default InviteActions;
